import type { DataGroupDto } from "../../types/DataGroupDto";
import type { DataGroupEntity } from "../../types/DataGroupEntity";

export const DataGroupDtoToEntity = ({ ...rest }: Readonly<DataGroupDto>): DataGroupEntity => {
    return { ...rest };
};
